import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import TermoDialog, { useOrganizador } from './TermoDialog';
import { formatarData } from '../../../utils/formatacao';

// Autorização de uso de imagem. Texto genérico: o organizador é o nome do tenant (branding).
function AutorizacaoUsoImagemDialog({ open, onClose, setChecked, nomeRepresentante, rg, cpf }) {
  const { t } = useTranslation();
  const organizador = useOrganizador();
  const hoje = formatarData(new Date(), { day: 'numeric', month: 'long', year: 'numeric' });

  return (
    <TermoDialog
      open={open}
      onClose={onClose}
      onAceitar={setChecked}
      titulo={t('termos.imagem.titulo')}
      textoAceitar={t('termos.imagem.aceitar')}
    >
      <Typography variant="body2" color="text.primary" paragraph>
        {t('termos.imagem.texto', { nome: nomeRepresentante || '—', rg: rg || '—', cpf: cpf || '—', organizador })}
      </Typography>
      <Typography variant="body2" color="text.primary" sx={{ mt: 3 }}>
        {hoje}
        <br />
        <b>{nomeRepresentante}</b>
      </Typography>
    </TermoDialog>
  );
}

export default AutorizacaoUsoImagemDialog;
